<template>
  <div>
    <vxe-grid
      ref="refTable"
      :columns="tableColumn"
      :data="tableData"
      :min-height="30"
      :edit-config="tableConfig.editConfig"
      :mouse-config="tableConfig.mouseConfig"
      :keyboard-config="tableConfig.keyboardConfig"
      :rowConfig="{
        isCurrent: false
      }"
    >
      <template #edit_get_counts="{ row }">
        <el-input v-model="row.get_counts" size="mini" class="flex-1" />
      </template>
      <template #edit_warehuose_name="{ row }">
        <el-input v-model="row.warehuose_name" size="mini" class="flex-1" />
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      tableColumn: [
        {
          title: '序号',
          type: 'seq',
          width: 50
        },
        {
          title: '物料名称',
          field: 'name'
        },
        {
          title: '规格',
          field: 'spec'
        },
        {
          title: '单位',
          field: 'unit'
        },
        {
          title: '数量',
          field: 'counts'
        },
        {
          title: '单价(元)',
          field: 'goods_price'
        },
        {
          title: '金额(元)',
          field: 'goods_amount'
        },
        {
          title: '领料数量',
          field: 'get_counts',
          slots: { edit: 'edit_get_counts' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '仓位',
          field: 'warehuose_name',
          slots: { edit: 'edit_warehuose_name' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '备注',
          field: 'remark'
        }
      ],
      tableData: []
    }
  },
  computed: {
    tableConfig() {
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return true
          }
        },
        keyboardConfig: {
          isEdit: true
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    tableData: {
      handler(newVal) {
        let result = this.$util.deepCopy(newVal)
        this.$emit('update:data', result)
      },
      deep: true
    }
  },
  mounted() {
    this.tableData = this.data || []
  }
}
</script>

<style scoped>
.table-main {
}
</style>
